export const DEFAULT_NOTIFICATION_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
};

export const NOTIFICATION_TYPES = {
  DEFAULT: 'default',
  SESSION_DURATION_NOTICE: 'session-duration-notice',
  REALITYCHECK: 'realityCheck',
  SESSION_EXPIRED: 'sessionExpired',
  SESSION_EXPIRED_POPUP: 'sessionExpiredPopup',
  SUSPENDED_USER: 'suspendedUser',
  ADDICTED_USER: 'addictedUser',
  UNVERIFIED_USER: 'unverifiedUser',
  IN_HOUSE_JACKPOT_WIN: 'inHouseJackpotWin',
  LUDOMAN_IN_VERIFICATION: 'ludomanInVerification',
  PASSPORT_VERIFICATION: 'passportVerification',
  ADDITIONAL_INFORMATION_UPLOAD_VERIFICATION:
    'additionalInformationUploadVerification',
  ADDITIONAL_INFORMATION_OTHER_VERIFICATION:
    'additionalInformationOtherVerification',
  VERIFIED_USER: 'verifiedUser',
  NOT_VERIFIED_USER: 'notVerifiedUser',
  MANDATORY_DEPOSIT_LIMIT: 'MANDATORY_DEPOSIT_LIMIT',
  REPEATED_VERIFICATION_REQUIRED: 'repeatedVerificationRequired',
  RG_SOCKET_MESSAGE: 'rgSocketMessage',
  WITHDRAWAL_LIMIT: 'withdrawalLimit'
};

export const MANDATORY_DEPOSIT_LIMIT_SUCCESS_NOTIFICATION_KEY =
  'web.notification.responsiblegambling.limitset';
